
export default {

    ISSUE_LIST: {
        SELECT: 'space',
        NEW: '+',
        CANCEL: 'escape',
        UP: 'up',
        DOWN: 'down'
    }
    
}



// WEBPACK FOOTER //
// ./src/actions/Keymap.js